/* eslint-disable */

//Object of helper functions that update map list

const highlightMapList = {

	highlightMapItem: (items, selectionId)=>{
		for(let i = 0; i < items.length; i++){
			if(items[i].id==selectionId){
				continue;
			}else{
				items[i].style.display="none";
			}
		}
	},

	resetMapItems: (items)=>{
		for(let i = 0; i < items.length; i++){
			items[i].style.display="block";
		}
	},

}



export default highlightMapList